import { MutationTree } from 'vuex';
import { AttachmentState } from './types';

export const mutations: MutationTree<AttachmentState> = {
  STORE(state, data: AttachmentState) {
    state.attachDocuments = data.attachDocuments
    state.buildingLocationFilesInfo = data.buildingLocationFilesInfo
  },
  CLEAR(state) {
    state.attachDocuments = false
    state.buildingLocationFilesInfo = []
  }
}
